import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import KhushiFullItineraryAdmin from "../Khushi/KhushiFullItineraryAdmin";
import { UsersTab } from "./components/UsersTab";
import { RevealsTab } from "./components/RevealsTab";
import { DashboardTab } from "./components/DashboardTab";
import { ResumeTab } from "./components/ResumeTab";
import { TasksTab } from "./components/TasksTab";
import { ChatTab } from "./components/ChatTab";
import { LogsTab } from "./components/LogsTab";
import { JarvisTheme } from "../theme/jarvisTheme";

const JARVIS = JarvisTheme;

type TopTab =
  | "dashboard"
  | "tasks"
  | "chat"
  | "logs"
  | "resume"
  | "users"
  | "archived";
type ArchivedTab = "fullItinerary" | "reveals";

function Jarvis() {
  const [tab, setTab] = useState<TopTab>("dashboard");
  const [archivedTab, setArchivedTab] =
    useState<ArchivedTab>("fullItinerary");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 4,
        px: 2,
        background: `radial-gradient(1200px 520px at 50% -10%, ${JARVIS.colors.accentSoft}, transparent 55%), linear-gradient(165deg, ${JARVIS.colors.bg1}, ${JARVIS.colors.bg0} 55%)`,
        color: JARVIS.colors.text,
      }}
    >
      <Box sx={{ maxWidth: { xs: "90%", md: 900 }, mx: "auto" }}>
        <Typography
          sx={{
            fontFamily:
              JARVIS.fonts.ui,
            fontWeight: 700,
            letterSpacing: "0.18em",
            color: JARVIS.colors.accent,
            fontSize: { xs: "1.35rem", sm: "1.6rem" },
            textAlign: "center",
            mb: 0.5,
          }}
        >
          JARVIS
        </Typography>
        <Typography
          sx={{
            fontFamily:
              JARVIS.fonts.mono,
            fontSize: "0.75rem",
            color: JARVIS.colors.muted,
            textAlign: "center",
            mb: 3,
            opacity: 0.9,
          }}
        >
          Owner console · telemetry · archived trip tools
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 1,
            mb: 2.5,
            flexWrap: "wrap",
          }}
        >
          <Button
            variant={tab === "dashboard" ? "contained" : "outlined"}
            onClick={() => setTab("dashboard")}
            sx={{
              fontFamily:
                JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "dashboard" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "dashboard" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor:
                  tab === "dashboard"
                    ? "rgba(88, 230, 255, 0.85)"
                    : JARVIS.colors.panel,
              },
            }}
          >
            Dashboard
          </Button>
          <Button
            variant={tab === "tasks" ? "contained" : "outlined"}
            onClick={() => setTab("tasks")}
            sx={{
              fontFamily: JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "tasks" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "tasks" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor:
                  tab === "tasks"
                    ? "rgba(88, 230, 255, 0.85)"
                    : JARVIS.colors.panel,
              },
            }}
          >
            Tasks
          </Button>
          <Button
            variant={tab === "chat" ? "contained" : "outlined"}
            onClick={() => setTab("chat")}
            sx={{
              fontFamily: JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "chat" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "chat" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor:
                  tab === "chat"
                    ? "rgba(88, 230, 255, 0.85)"
                    : JARVIS.colors.panel,
              },
            }}
          >
            Chat
          </Button>
          <Button
            variant={tab === "logs" ? "contained" : "outlined"}
            onClick={() => setTab("logs")}
            sx={{
              fontFamily: JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "logs" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "logs" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor:
                  tab === "logs"
                    ? "rgba(88, 230, 255, 0.85)"
                    : JARVIS.colors.panel,
              },
            }}
          >
            Logs
          </Button>
          <Button
            variant={tab === "resume" ? "contained" : "outlined"}
            onClick={() => setTab("resume")}
            sx={{
              fontFamily: JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "resume" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "resume" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor: tab === "resume" ? "rgba(88, 230, 255, 0.85)" : JARVIS.colors.panel,
              },
            }}
          >
            Resume
          </Button>
          <Button
            variant={tab === "users" ? "contained" : "outlined"}
            onClick={() => setTab("users")}
            sx={{
              fontFamily:
                JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "users" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "users" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor:
                  tab === "users"
                    ? "rgba(88, 230, 255, 0.85)"
                    : JARVIS.colors.panel,
              },
            }}
          >
            Users
          </Button>
          <Button
            variant={tab === "archived" ? "contained" : "outlined"}
            onClick={() => setTab("archived")}
            sx={{
              fontFamily:
                JARVIS.fonts.ui,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              borderColor: JARVIS.colors.panelBorder,
              color: tab === "archived" ? JARVIS.colors.bg0 : JARVIS.colors.muted,
              bgcolor: tab === "archived" ? JARVIS.colors.accent : "transparent",
              "&:hover": {
                borderColor: JARVIS.colors.accent,
                bgcolor:
                  tab === "archived"
                    ? "rgba(88, 230, 255, 0.85)"
                    : JARVIS.colors.panel,
              },
            }}
          >
            Archived
          </Button>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 1,
            border: `1px solid ${JARVIS.colors.panelBorder}`,
            bgcolor: JARVIS.colors.panel,
            boxShadow: JARVIS.effects.panelShadow,
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          {tab === "dashboard" ? (
            <DashboardTab />
          ) : tab === "tasks" ? (
            <TasksTab />
          ) : tab === "chat" ? (
            <ChatTab />
          ) : tab === "logs" ? (
            <LogsTab />
          ) : tab === "resume" ? (
            <ResumeTab />
          ) : tab === "users" ? (
            <UsersTab />
          ) : (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                  mb: 2,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant={
                    archivedTab === "fullItinerary" ? "contained" : "outlined"
                  }
                  onClick={() => setArchivedTab("fullItinerary")}
                  sx={{
                    fontFamily:
                      JARVIS.fonts.ui,
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    borderColor: JARVIS.colors.panelBorder,
                    color:
                      archivedTab === "fullItinerary"
                        ? JARVIS.colors.bg0
                        : JARVIS.colors.muted,
                    bgcolor:
                      archivedTab === "fullItinerary"
                        ? JARVIS.colors.accent
                        : "transparent",
                    "&:hover": {
                      borderColor: JARVIS.colors.accent,
                      bgcolor:
                        archivedTab === "fullItinerary"
                          ? "rgba(88, 230, 255, 0.85)"
                          : "rgba(12, 18, 30, 0.85)",
                    },
                  }}
                >
                  Full Itinerary
                </Button>
                <Button
                  variant={archivedTab === "reveals" ? "contained" : "outlined"}
                  onClick={() => setArchivedTab("reveals")}
                  sx={{
                    fontFamily:
                      JARVIS.fonts.ui,
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    borderColor: JARVIS.colors.panelBorder,
                    color:
                      archivedTab === "reveals"
                        ? JARVIS.colors.bg0
                        : JARVIS.colors.muted,
                    bgcolor:
                      archivedTab === "reveals"
                        ? JARVIS.colors.accent
                        : "transparent",
                    "&:hover": {
                      borderColor: JARVIS.colors.accent,
                      bgcolor:
                        archivedTab === "reveals"
                          ? "rgba(88, 230, 255, 0.85)"
                          : "rgba(12, 18, 30, 0.85)",
                    },
                  }}
                >
                  Reveals
                </Button>
              </Box>

              {archivedTab === "fullItinerary" ? (
                <KhushiFullItineraryAdmin />
              ) : (
                <RevealsTab />
              )}
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
}

export default Jarvis;

